import React from 'react'
import "./Grow.css";
import Grow1 from '../images/png/image110.png'

const Grow=()=>{
  return (
    <div>
        <div className='grow' style={{backgroundImage:`url(${Grow1})`}}>
            <div className='freelancing'>
                <h1>Grow your freelancing <br/>career with Fliqa Associate</h1>
                <button type="submit"> Join Now</button>
            </div>
            <div className='register'>
                <p> Register yourself <br/>
                 Verification & Quality Check<br/>
                 Verified Associate at FliqaIndia</p>
            </div>
            
        </div>
    </div>
  )
}
export {Grow}
